//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductHeader from './ProductHeader.vue'
import ProductNav from './ProductNav.vue'
import Intro from './Intro.vue'
import Question from './Question.vue'
import Message from './Message.vue'
import Process from './Process.vue'
import Buy from './Buy.vue'
import Measure from './Measure.vue'
import API from '../api'
import qs from 'qs'
import URL from '../utils/URL'
import Cookie from '../utils/Cookie'
import Window from '../utils/Window'

// import AppConfig from '../config/app'
const code = URL.getQueryString('code')

export default {
  name: 'm-product',
  data () {
    return {
      codeOK: false,
      showWhat: false,
      // followWX: false,
      // currentHref: '',
      showFixedNav: false, // 解决iOS的fixed定位问题
      scrollTop: 0, // 滚动的距离
      navOffsetTop: 0, // 导航距离父元素的距离
      nav1OffsetTop: 0, // 产品介绍距离父元素的距离
      nav2OffsetTop: 0, // 常见问题距离父元素的距离
      nav3OffsetTop: 0, // 用户评价距离父元素的距离
      nav4OffsetTop: 0, // 理赔流程距离父元素的距离
      active: {}, // 位置信息传给导航
      scrollTo: 0, // 需要滚动到的位置
      measureState: false, // 保费测算状态
      showAgent: false,
      agentName: '',
      agentJobNum: '',
      show: false        // 默认不显示页面
    }
  },
  computed: {
    h5 () {
      if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
        return true
      }
      return false
    },
    isDailiren () {
      // 是合伙人
      // 不是悟空保，且不是H5
      // 是否是悟空保的innerCode
      const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) !== -1
      if (!this.h5 && !isWKB) {
        return true
      }
      return false
    }
  },
  beforeMount () {
    // this.currentHref = window.location.href
    // if (localStorage.getItem(this.currentHref) !== 'activated') {
    //   this.followWX = true
    // }
  },
  mounted () {
    // history.pushState(null, null, window.location.href)
    // if (window.addEventListener) {
    //   window.addEventListener('popstate', this.go)
    // } else if (window.attachEvent) {
    //   window.attachEvent('onpopstate', this.go)
    // }
    // window.jQuery(window).on('popstate', this.go)
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)

    // 正在活动中并且是微信，并且是悟空保innerCode
    if (this.$store.state.activity.status && Window.isWX() && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) {
      // const cacheOpenId = window.localStorage.getItem(code)
      const cacheOpenId = Cookie.getCookie('session_wechat_user_openid')
      let redirectUri = this.$store.state.activity.redirectURL + '/#/' + this.$store.state.order.userId + '/' + this.$store.state.order.productId + '/?' + qs.stringify(this.$route.query)
      if (this.$route.query.activityCode) {
        redirectUri += '?activityCode=' + this.$route.query.activityCode
      }
      const authorizationURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.$store.state.activity.appid + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=code&scope=snsapi_base#wechat_redirect'
      if (cacheOpenId === null) {
        if (code === null) {
          window.location.href = authorizationURL
        } else {
          this.$http.get('/api/interface/getOpenIdByCode?code=' + code).then((response) => {
            if (response.data.openid) {
              this.codeOK = true
              Cookie.setCookie('session_wechat_user_openid', response.data.openid)
            } else {
              window.location.href = authorizationURL
            }
          })
        }
      } else {
        this.codeOK = true
      }
    } else {
      this.codeOK = true
    }

    // 代理人
    const agentCode = this.$route.query.agentCode
    const supAgentCode = this.$route.query.supAgentCode
    // if (Window.isWX() && this.h5 && (agentCode === undefined || agentCode === null || agentCode === '') && supAgentCode === 'true') {
    //   this.showAgent = true
    // }

    const shareData = {}
    shareData.title = '至尊保之优爱宝定期寿险'
    shareData.desc = '性价比完胜香港保险 按需灵活投保 保障最优 价格最低 后顾无忧'
    shareData.link = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + '#/' + this.$route.params.userId + '/' + this.$route.params.productId
    // shareData.link = window.location.href.replace(/activityCode=\d+&?/, '')
    shareData.imgUrl = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/wechat_share.png'

    let url = encodeURIComponent(window.location.href.replace(/#.+$/, '')) // 最后的 / 一定要有
    // 页面标题
    if (this.h5) {
      document.title = '至尊保定期寿险'
      // 配置信息
      API.getH5Configuration(this).then(data => {
        this.show = true
        if (data !== null) {
          shareData.title = this.$store.state.h5.configuration.shareTitle || '至尊保之优爱宝定期寿险'
          shareData.desc = this.$store.state.h5.configuration.shareDesc || '性价比完胜香港保险 按需灵活投保 保障最优 价格最低 后顾无忧'
          shareData.link = window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + '#/' + this.$route.params.userId + '/' + this.$route.params.productId + '/?' + qs.stringify(this.$route.query)
          shareData.imgUrl = this.$store.state.h5.configuration.shareImgurl || window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/wechat_share.png'
          this.$wechat.ready(() => {
            // 需要代理人信息
            // 隐藏微信分享
            if (this.showAgent) {
              this.$wechat.hideMenuItems({
                menuList: [
                  'menuItem:share:appMessage',
                  'menuItem:share:timeline',
                  'menuItem:share:qq',
                  'menuItem:share:weiboApp',
                  'menuItem:share:facebook',
                  'menuItem:share:QZone'
                ]
              })
            }
            // 分享给朋友
            this.$wechat.onMenuShareAppMessage({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到朋友圈
            this.$wechat.onMenuShareTimeline({
              title: shareData.title, // 分享标题
              link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到QQ
            this.$wechat.onMenuShareQQ({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到腾讯微博
            this.$wechat.onMenuShareWeibo({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl // 分享图标
            })
          })
          this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
            this.$wechat.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: response.data.appId, // 必填，公众号的唯一标识
              timestamp: response.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
              signature: response.data.signature, // 必填，签名，见附录1
              jsApiList: [
                'hideMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareQZone'
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          })
        } else {
          // 需要代理人信息
          // 隐藏微信分享
          if (this.showAgent) {
            this.$wechat.hideMenuItems({
              menuList: [
                'menuItem:share:appMessage',
                'menuItem:share:timeline',
                'menuItem:share:qq',
                'menuItem:share:weiboApp',
                'menuItem:share:facebook',
                'menuItem:share:QZone'
              ]
            })
          }
          this.$wechat.ready(() => {
            // 分享给朋友
            this.$wechat.onMenuShareAppMessage({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到朋友圈
            this.$wechat.onMenuShareTimeline({
              title: shareData.title, // 分享标题
              link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到QQ
            this.$wechat.onMenuShareQQ({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl // 分享图标
            })
            // 分享到腾讯微博
            this.$wechat.onMenuShareWeibo({
              title: shareData.title, // 分享标题
              desc: shareData.desc, // 分享描述
              link: shareData.link, // 分享链接
              imgUrl: shareData.imgUrl // 分享图标
            })
          })
          this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
            this.$wechat.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: response.data.appId, // 必填，公众号的唯一标识
              timestamp: response.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
              signature: response.data.signature, // 必填，签名，见附录1
              jsApiList: [
                'hideMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareQZone'
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          })
        }
      })
    } else {
      this.show = true
      // 合伙人分享参数设置
      if (this.isDailiren) {
        // this.$route.query.isShare = 'true'
        // this.$route.query.isProspectus = 'true'
        shareData.link += '?isShare=true&isProspectus=true'
      }
      this.$wechat.ready(() => {
        // 分享给朋友
        this.$wechat.onMenuShareAppMessage({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到朋友圈
        this.$wechat.onMenuShareTimeline({
          title: shareData.title, // 分享标题
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到QQ
        this.$wechat.onMenuShareQQ({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到腾讯微博
        this.$wechat.onMenuShareWeibo({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        })
      })
      this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
        this.$wechat.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: response.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.signature, // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
      this.$http.get('/api/hqdqx/getAgentUserInfo/' + this.$store.state.order.userId).then(response => {
        document.title = ((response.data.authorityStatus === 3 && response.data.name) || response.data.nickname || response.data.phone) + '推荐：至尊保定期寿险'
      })
    }
  },
  destroyed () {
    // if (window.removeEventListener) {
    //   window.removeEventListener('popstate', this.go)
    // } else if (window.detachEvent) {
    //   window.detachEvent('onpopstate', this.go)
    // }
    // window.jQuery(window).off('popstate', this.go)
  },
  components: {
    [ProductHeader.name]: ProductHeader,
    [ProductNav.name]: ProductNav,
    [Process.name]: Process,
    [Message.name]: Message,
    [Question.name]: Question,
    [Intro.name]: Intro,
    [Buy.name]: Buy,
    [Measure.name]: Measure
  },
  methods: {
    // go (event) {
    //   // window.history.pushState('forward', null, '#')
    //   window.history.forward(1)
    //   // history.go(1)
    // },
    onScroll (scrollTop) {
      this.scrollTop = scrollTop
      this.navOffsetTop = this.$refs.nav.offsetTop
      this.nav1OffsetTop = this.$refs.nav1.$el.offsetTop
      this.nav2OffsetTop = this.$refs.nav2.$el.offsetTop
      this.nav3OffsetTop = this.$refs.nav3.$el.offsetTop
      this.nav4OffsetTop = this.$refs.nav4.$el.offsetTop
      this.active = { nav1: this.nav1OffsetTop, nav2: this.nav2OffsetTop, nav3: this.nav3OffsetTop, nav4: this.nav4OffsetTop, scroller: this.$refs.scroller.$el.querySelector('.scroller') }
    },
    reActiveNav () {
      setTimeout(() => {
        this.navOffsetTop = this.$refs.nav.offsetTop
        this.nav1OffsetTop = this.$refs.nav1.$el.offsetTop
        this.nav2OffsetTop = this.$refs.nav2.$el.offsetTop
        this.nav3OffsetTop = this.$refs.nav3.$el.offsetTop
        this.nav4OffsetTop = this.$refs.nav4.$el.offsetTop
        this.active = { nav1: this.nav1OffsetTop, nav2: this.nav2OffsetTop, nav3: this.nav3OffsetTop, nav4: this.nav4OffsetTop, scroller: this.$refs.scroller.$el.querySelector('.scroller') }
      }, 100)
    },
    recordScroll () {
      localStorage.setItem('scroll', 'true')
      localStorage.setItem('scrollTo', this.scrollTop)
    },
    onClickNav (data) {
      this.scrollTo = this.$refs[data].$el.offsetTop
      this.$refs.scroller.$el.querySelector('.scroller').scrollTop = this.scrollTo - 50
    },
    onClickBuy () {
      console.log(this.measureState)
      this.measureState = !this.measureState
      if (!this.measureState) {
        this.$router.push({name: 'Notify', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId}, query: this.$route.query})
      }
    },
    messageReady () {
      if (localStorage.getItem('scroll')) {
        this.scrollTo = localStorage.getItem('scrollTo')
        this.$refs.scroller.$el.querySelector('.scroller').scrollTop = this.scrollTo
        localStorage.removeItem('scroll')
      }
    },
    onShowWhat () {
      this.showWhat = true
    },
    onCloseWhat () {
      this.showWhat = false
    },
    checkAgentName () {
      if (this.agentName === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入姓名',
          position: 'top',
          width: '20em'
        })
        return false
      }
      return true
    },
    checkAgentJobNum () {
      if (this.agentJobNum === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入工号',
          position: 'top',
          width: '20em'
        })
        return false
      }
      return true
    },
    onConfirmAgent () {
      if (!this.checkAgentName() || !this.checkAgentJobNum()) return
      this.showAgent = false
      if (window.location.href.indexOf('agentCode') !== -1) {
        window.location.href = window.location.href.replace(/agentCode.*?(?=(&|$))/, 'agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum))
        window.location.reload()
      } else {
        window.location.href = window.location.href + '&agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum)
        window.location.reload()
      }
    },
    onCloseFollowWX () {
      this.followWX = false
      localStorage.setItem(this.currentHref, 'activated')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Product.vue